import React from "react";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";
import telIcon from './images/i-4.svg';
import maxIcon from './images/max.svg'

export default function Contacts() {
  const defaultState = {
    center: [61.25073, 73.431852],
    zoom: 15,
  };

  return (
    <>
      <div className="container-0" id="contacts">
        <div className="arrows">
          <h2>Мы на связи</h2>
        </div>
        <div className="container-contacts">
          <YMaps>
            <Map defaultState={defaultState} className="y-map">
              <Placemark geometry={[61.25073, 73.431852]} />
            </Map>
          </YMaps>
          <div className="contacts">
            <div className="contacts-tel">
              <h2>Контакты</h2>
              <p>​Сургут, Университетская, 23/5</p>
              <a className="tel" href="tel:+73462380894">
                <img src={telIcon} alt="" className="contacts-img" />
                Позвонить
              </a>
              <a className="tel contacts-whatsapp" href="https://max.ru/u/f9LHodD0cOId4bgT0_F2TCeGrRlKHW0BK8b7AveoRH2p3O2aka1c8cay4Us" target="_blank" rel="noopener noreferrer">
                <img src={maxIcon} alt="MAX" className="contacts-img" />
                MAX
              </a>
              <br />
              <p className="contacts-descr">
                Записаться на прием можно по телефону, MAX или по кнопке
                ниже.
              </p>
              <div className="contacts-block" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <img src="/img/qr.jpg" alt="QR-code" width={150}/>
                <h2>Оцените наши услуги</h2>
              </div>
            </div>
            <div className="working-hours">
              <div>
                <div className="work-day">
                  <p>Будни:</p>
                  <p>8:00 - 21:00</p>
                </div>
                <div className="work-day">
                  <p>Сб, вс:</p>
                  <p>10:00 - 20:00</p>
                </div>
              </div>
              <a
                href="https://max.ru/u/f9LHodD0cOId4bgT0_F2TCeGrRlKHW0BK8b7AveoRH2p3O2aka1c8cay4Us"
                className="ms_booking signup-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-services">
                  ЗАПИСАТЬСЯ
                </button>
              </a>
            </div>
          </div>
        </div>
        {/* <div>
          <img src="/img/poster.png" alt="Постер" width={1000}/>
        </div> */}
      </div>
      {/* <div className="container">
            
            
        </div> */}
    </>
  );
}
